const variables = {
  mainNavigationLargeHeight: 88,
  mainNavigationLargeMarginTop: 0,
  mainNavigationLargeProfileMenuButtonVariant: 'tertiary',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 8,
  mainNavigationSmallProfileMenuButtonVariant: 'primary',
};

export default variables;
